import { MessageBusService } from "@/shared/message-bus";
import { CellClickedEvent, GridReadyEvent } from "@ag-grid-community/core";
import { Location } from "@angular/common";
import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation, } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { GLSubmission } from "app/model/entities/entity-model";
import { AgFns, GridOptionsExt, ISortModel, RowSelectionMultipleCheckbox, } from "app/shared/ag-fns";
import { AgStyleFns } from "app/shared/ag-style-fns";
import { DomainBaseComponent } from "app/shared/domain-base.component";
import { DomainService } from "app/shared/domain.service";
import { NavFns } from "app/shared/nav-fns";
import { LinkHelpTooltipComponent } from "app/shared/tooltip.component";
import { takeUntil } from "rxjs/operators";

@Component({
  templateUrl: "./qb-submission.component.html",

  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class QbSubmissionComponent
  extends DomainBaseComponent
  implements OnInit {
  @ViewChild("eiButtonsCell") eiButtonsCell: TemplateRef<any>;

  glGridOptions: GridOptionsExt;
  glSubmissions: GLSubmission[];

  constructor(
    protected domainService: DomainService,
    protected route: ActivatedRoute,

    protected location: Location,
    protected messageBus: MessageBusService
  ) {
    super(domainService);

    this.route.paramMap.pipe(takeUntil(this.onDestroy)).subscribe(() => {
      this.updateFromContext();
    });
  }

  async updateFromContext() {
    this.glGridOptions = AgFns.initGridOptions(this, {
      onGridReady: this.onGlGridReady,
      onModelUpdated: (p) => { }, // need to suppress automatic autosize that occurs here.
      getRowHeight: undefined, // // we want autoHeight for this grid
    });

    this.glSubmissions = await this.dbQueryService.uow.createQuery(GLSubmission).execute();
    this.isPageReady = true;
  }

  async canDeactivate() {
    const ok = await super.canDeactivate();
    if (!ok) return false;
    this.uow.clearEntities(GLSubmission);
    return true;
  }

  async onGlGridReady(event: GridReadyEvent) {
    const colDefs = [
      {
        headerName: "Entity Type",
        field: "tableName",
        filter: "agTextColumnFilter",
        width: 100,
      },
      {
        headerName: "Entity Id",
        field: "entityId",
        filter: "agTextColumnFilter",
        width: 100,
        cellClass: AgStyleFns.getLinkCellClass(),
        onCellClicked: (event) =>
          this.gotoIssue(event, event.data as GLSubmission),
        tooltipComponent: LinkHelpTooltipComponent,
        tooltipField: "entityId",
      },
      {
        headerName: "Confirmation Key",
        field: "confirmationKey",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Error",
        field: "errorMessage",
        filter: "agTextColumnFilter",
        width: 500,
        tooltipField: "errorMessage",
        cellStyle: { "white-space": "normal" },
        autoHeight: true,
        wrapText: true,
      },
      { headerName: "Submission Date", field: "submissionTs", width: 140 },
      { headerName: "Previously Submitted", field: "wasPreviouslySubmitted", width: 140 },
      { headerName: "Created On", field: "crtnTs", width: 140 },
    ];

    const sortModel = [{ colId: "crtnTs", sort: "desc" }] as ISortModel;

    AgFns.initGrid(event, colDefs, sortModel);
    AgFns.sizeColumnsToFit(this.glGridOptions);

    this.glGridOptions.apiX.resetRowHeights();
  }

  async gotoIssue(event: CellClickedEvent, issue: GLSubmission) {
    if (issue.entityId == null) return;
    if (issue.tableName === "JoHeader") {
      this.gotoNavPath(event, "/in-process/manage/job-orders", issue.entityId);
    } else if (issue.tableName === "InvoiceHeader" || issue.tableName === "InvoicePayment") {
      const navPath = "/printable-invoice/" + issue.entityId;
      NavFns.navigateWithClickEvent(event, this.router, navPath, {});
    } else if (issue.tableName === "CreditMemo") {
      NavFns.navigateWithClickEvent(event, this.router, "/returns-inbox", {});
    } else {
      return await this.dialogService.showOkMessage(
        "Not yet implemented",
        `Navigation to this type of issue has not yet been implemented`
      );
    }
  }

  private gotoNavPath(event, navPath: string, id: any, idName = "id") {
    const fm = AgFns.addFilterClause({}, idName, "number", id);
    const urlSuffix = encodeURIComponent(JSON.stringify(fm));
    const params = {
      queryParams: {
        fm: urlSuffix,
        key: id.toString(),
      },
    };
    NavFns.navigateWithClickEvent(event, this.router, navPath, params);
  }


}
